var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scan-guide" }, [
    _c("header", { staticClass: "brand" }, [
      _c("span", { staticClass: "brand-ic" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 64 34",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("rect", {
              attrs: {
                x: "2",
                y: "2",
                width: "56",
                height: "24",
                rx: "7",
                fill: "#fff"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "2",
                y: "20",
                width: "56",
                height: "3",
                fill: "#07c160"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "7",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "20",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "33",
                y: "7",
                width: "9",
                height: "9",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                x: "46",
                y: "7",
                width: "7",
                height: "16",
                rx: "2",
                fill: "#0b3d33"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
            }),
            _vm._v(" "),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
            }),
            _c("circle", {
              attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v("果城行丨公共出行服务查询")])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "card" }, [
      _c("div", { staticClass: "frame" }, [
        _c("i", { staticClass: "c c1" }),
        _c("i", { staticClass: "c c2" }),
        _c("i", { staticClass: "c c3" }),
        _c("i", { staticClass: "c c4" }),
        _vm._v(" "),
        _c("div", { staticClass: "frame-inner" }, [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 120 100",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: { d: "M97 88 L101 99 L86 92 Z", fill: "#0BBF6B" }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "83",
                  cy: "68",
                  rx: "27",
                  ry: "21",
                  fill: "#0BBF6B"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "74",
                  cy: "67",
                  rx: "3.2",
                  ry: "3.9",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "93",
                  cy: "67",
                  rx: "3.2",
                  ry: "3.9",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: { d: "M31 65 L24 84 L47 70 Z", fill: "#07C160" }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "43",
                  cy: "38",
                  rx: "34",
                  ry: "27",
                  fill: "#07C160"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "32",
                  cy: "35",
                  rx: "3.6",
                  ry: "4.4",
                  fill: "#fff"
                }
              }),
              _vm._v(" "),
              _c("ellipse", {
                attrs: {
                  cx: "55",
                  cy: "35",
                  rx: "3.6",
                  ry: "4.4",
                  fill: "#fff"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "scanline" })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "frame-cap" }, [_vm._v("仅限微信扫码进入")]),
      _vm._v(" "),
      _c("div", { staticClass: "app-badge" }, [
        _c("span", { staticClass: "dot" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "检测到「" + _vm._s(_vm.detectedApp) + "」打开 · 无法进入小程序"
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "banner-tip" }, [
        _vm._v("🚌 公交到站实时查询 · 无需下载 · 微信扫码即用")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "road" }, [
      _c(
        "svg",
        {
          staticClass: "bus",
          attrs: {
            viewBox: "0 0 64 34",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("rect", {
            attrs: {
              x: "2",
              y: "2",
              width: "56",
              height: "24",
              rx: "7",
              fill: "#ffffff"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "2",
              y: "20",
              width: "56",
              height: "3",
              fill: "#07c160"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "7",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "20",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "33",
              y: "7",
              width: "9",
              height: "9",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "46",
              y: "7",
              width: "7",
              height: "16",
              rx: "2",
              fill: "#0b3d33"
            }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "16", cy: "27", r: "5", fill: "#1f2937" }
          }),
          _c("circle", {
            attrs: { cx: "16", cy: "27", r: "2", fill: "#cfd8dc" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "46", cy: "27", r: "5", fill: "#1f2937" }
          }),
          _c("circle", {
            attrs: { cx: "46", cy: "27", r: "2", fill: "#cfd8dc" }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("footer", { staticClass: "foot" }, [
      _vm._v("南充七安网络科技有限公司 · 提供技术支持")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _vm._v("请用"),
      _c("em", [_vm._v("微信扫一扫")]),
      _c("br"),
      _vm._v("进入小程序")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "sub" }, [
      _vm._v("\n      站台二维码对应"),
      _c("strong", [_vm._v("微信小程序")]),
      _c("br"),
      _vm._v("\n      相机、支付宝、浏览器等软件扫码均无法打开\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "steps" }, [
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("1")]),
        _c("span", [
          _vm._v("打开"),
          _c("b", [_vm._v("微信")]),
          _vm._v("，点右上角"),
          _c("span", { staticClass: "plus" }, [_vm._v("＋")])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("2")]),
        _c("span", [_vm._v("选择"), _c("b", [_vm._v("「扫一扫」")])])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "num" }, [_vm._v("3")]),
        _c("span", [_vm._v("对准站台上的二维码，即可进入小程序")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ddcc4950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddcc4950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/miniUrl/alipay.vue
// module id = null
// module chunks = 